// 🔧 entries.js
// ✅ Purpose: Fictional partner entry templates for the SAP NOW Milan AI Agents Challenge Experience
// ✅ Features:
// - Defines exactly thirteen fictional demo partner teams
// - Gives every partner a distinct AI-agent use case for a realistic customer demonstration
// - Does not represent or imply SAP-confirmed participating companies
// - Keeps partner content separate from generator and Firestore persistence logic
// - Can be replaced with the actual SAP participant list when SAP supplies it
// - Fully block-commented for clarity and future devs

export const SAP_AI_AGENTS_CHALLENGE_ENTRIES = [
  {
    regcnt: "#SAP-01",
    partnerName: "Aurora Agent Labs",
    focusArea: "Customer Service",
    description:
      "An AI service agent that resolves complex customer requests by coordinating SAP customer, order, and service information.",
  },
  {
    regcnt: "#SAP-02",
    partnerName: "BluePeak Intelligence",
    focusArea: "Supply Chain",
    description:
      "A supply-chain agent that detects disruptions, evaluates alternatives, and recommends responsive sourcing and fulfillment actions.",
  },
  {
    regcnt: "#SAP-03",
    partnerName: "Cedar Bridge AI",
    focusArea: "Finance",
    description:
      "A finance operations agent that investigates exceptions, summarizes financial context, and assists teams with resolution workflows.",
  },
  {
    regcnt: "#SAP-04",
    partnerName: "DeltaNova Systems",
    focusArea: "Procurement",
    description:
      "A procurement agent that helps teams evaluate sourcing needs, supplier information, and purchasing actions across business processes.",
  },
  {
    regcnt: "#SAP-05",
    partnerName: "Evergreen Agentworks",
    focusArea: "Sustainability",
    description:
      "A sustainability agent that brings together operational data and business context to support environmental performance decisions.",
  },
  {
    regcnt: "#SAP-06",
    partnerName: "FluxPoint AI",
    focusArea: "Manufacturing",
    description:
      "A manufacturing agent that identifies production issues, gathers supporting context, and recommends coordinated operational responses.",
  },
  {
    regcnt: "#SAP-07",
    partnerName: "GraniteLoop Technologies",
    focusArea: "Asset Management",
    description:
      "An asset-management agent that assists maintenance teams with equipment context, work history, and recommended follow-up actions.",
  },
  {
    regcnt: "#SAP-08",
    partnerName: "HelioPath Solutions",
    focusArea: "Human Resources",
    description:
      "An employee-support agent that helps answer workforce questions and navigate common HR service workflows using governed enterprise context.",
  },
  {
    regcnt: "#SAP-09",
    partnerName: "Ironwood Digital",
    focusArea: "Sales",
    description:
      "A sales agent that synthesizes account, opportunity, and product context to help sales teams prepare and prioritize next actions.",
  },
  {
    regcnt: "#SAP-10",
    partnerName: "JuniperWorks AI",
    focusArea: "Commerce",
    description:
      "A commerce agent that helps teams understand customer demand, product context, and order activity while coordinating follow-up workflows.",
  },
  {
    regcnt: "#SAP-11",
    partnerName: "Kinetic Harbor",
    focusArea: "Business Planning",
    description:
      "A planning agent that brings operational and financial signals together to surface scenarios, risks, and recommended business responses.",
  },
  {
    regcnt: "#SAP-12",
    partnerName: "LuminaGrid Systems",
    focusArea: "Data and Analytics",
    description:
      "An analytics agent that converts enterprise questions into governed insights and explains the business context behind its findings.",
  },
  {
    regcnt: "#SAP-13",
    partnerName: "Meridian Agentic",
    focusArea: "Enterprise Operations",
    description:
      "A cross-functional enterprise agent that coordinates multi-step work across business processes while keeping users informed and in control.",
  },
];